import script from "./jdProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./jdProduct.vue?vue&type=script&setup=true&lang=js"

import "./jdProduct.vue?vue&type=style&index=0&id=a7284162&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7284162"]])

export default __exports__